import React, { useState, useEffect } from "react";
import {
  Input,
  Form,
  Col,
  Row,
  Button,
  Select,
  Collapse,
  DatePicker,
  Typography,
  InputNumber
} from "antd";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";
import moment from "moment";

const CommissionReportTableFilter = (props) => {
  const [data, setData] = useState(props.data);
  const [form] = Form.useForm();

  const [bankSelect, setBankSelect] = useState({
    data: [],
    loading: false,
  });

  useEffect(() => {
    setBankSelect({
      ...bankSelect,
      loading: true,
    });
    RequestHandler.get(`/PosTransaction/AddedBanks?$select=id,name`).then(
      (response) => {
        setBankSelect({
          data: response,
          loading: false,
        });
      }
    );

    if (props.data) {
      form.setFieldsValue(props.data);
    }
  }, []);

  useEffect(() => {
    form.setFieldsValue(data);
  }, [data]);

  const onFinish = (values) => {
    {
      let query = "";
      let queryDate = "";
      const conditions = [];

      if (values.bankId) {
        conditions.push(`bankId eq ${values.bankId}`);
      }

      if (values.installmentCount) {
        conditions.push(`installmentCount eq ${values.installmentCount}`);
      }

      if (values.onusNotonusId) {
        conditions.push(`onusNotonusId eq ${values.onusNotonusId==-1?0:values.onusNotonusId}`);
      }
      if (values.queryDate) {
        queryDate = values.queryDate.format("YYYY-MM-01");
      }

      if (conditions.length !== 0) {
        query = "&$filter=" + conditions.join(" and ");
      }

      if (props.onFinishFilter) props.onFinishFilter(query, queryDate);
    }
  };

  const clearFilter = () => {
    form.resetFields();

    if (props.onClearFilter) {
      props.onClearFilter();
    }
  };

  return (
    <Row id="filterArea" style={{ ...props.style }}>
      <Col span={24}>
        <Collapse>
          <Collapse.Panel
            header="Filtreleme için tıklayınız."
            extra={
              props.extraText ? (
                <Typography>
                  <Typography.Paragraph
                    style={{
                      marginBottom: 0,
                      fontSize: "80%",
                    }}
                    type="secondary"
                  >
                    {props.extraText}
                  </Typography.Paragraph>
                </Typography>
              ) : null
            }
          >
            <Form
              name="tenantFilter"
              form={form}
              initialValues={{
                remember: true,
              }}
              layout="vertical"
              onFinish={onFinish}
            >
              <Row style={{ flexDirection: "row" }}>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="bankId" label="Banka :">
                    <Select
                      allowClear
                      showSearch
                      placeholder="Tümü"
                      loading={bankSelect.loading}
                      filterOption={(input, option) =>
                        option.props.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                    >
                      {bankSelect.data.map((item) => (
                        <Select.Option key={item.id} value={item.id}>
                          {item.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="installmentCount" label="Taksit Sayısı :">
                    <InputNumber
                      allowClear
                      style={{ width: "100%" }}
                      min={1}
                      max={12}
                      precision={0}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>

                  <Form.Item name="queryDate" label="Sorgu Tarihi :">
                    <DatePicker
                      picker="month"
                      format="MMMM YYYY"
                      style={{ width: "100%" }}
                      allowClear
                      disabledDate={(current) => current.startOf("month").isAfter(moment().startOf("month"))}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="onusNotonusId" label="Tip :">
                    <Select
                      allowClear
                      placeholder="Tümü"
                    >
                      <Select.Option key={-1} value={-1}>
                        Bilinmiyor
                      </Select.Option>
                      <Select.Option key={1} value={1}>
                        Onus
                      </Select.Option>
                      <Select.Option key={2} value={2}>
                        NotOnus
                      </Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              <Row style={{ flexDirection: "row" }}>
                <Col span={24} style={{ textAlign: "right" }}>
                  <Button
                    danger
                    size="small"
                    icon={<CloseOutlined />}
                    onClick={() => clearFilter()}
                  >
                    Sıfırla
                  </Button>
                  <Button
                    type="primary"
                    size="small"
                    icon={<SearchOutlined />}
                    style={{ color: "#40a9ff", borderColor: "#40a9ff" }}
                    htmlType="submit"
                  >
                    Filtrele
                  </Button>
                </Col>
              </Row>
            </Form>
          </Collapse.Panel>
        </Collapse>
      </Col>
    </Row>
  );
};
export default CommissionReportTableFilter;
